<app-header></app-header>
<app-popup></app-popup>
<app-digital-consent></app-digital-consent>
<router-outlet></router-outlet>
<app-footer></app-footer>
